/* GENERATED FROM changeMgr.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as commonHdr from './commonHdr.service'

export class ChangeMgr {
  static GetChanges = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetChangesReq, {}, GetChangesResp>): Promise<
    APIResponse<GetChangesResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/changes`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetChangesResp>>()
          .then<APIResponse<GetChangesResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetChangesCount = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetChangesCountReq, {}, GetChangesCountResp>): Promise<
    APIResponse<GetChangesCountResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/changes/count`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetChangesCountResp>>()
          .then<APIResponse<GetChangesCountResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface ChangeInfo {
  change_id?: string
  date?: string
  source_type?: commonHdr.ResourceTypeEnum
  dest_type?: commonHdr.ResourceTypeEnum
  change_type?: ChangeTypeEnum
  severity?: commonHdr.AlertSeverityEnum
  description?: string
  alert_count?: string
  snapshot_id?: string
  source_name?: string
  dest_name?: string
  resource_list?: string[]
  from_account_id?: string
  to_account_id?: string
  node_id?: string
  edge_id?: string
  changed_by?: string
  changed_by_account_id?: string
  changed_by_type?: string
}

export interface GetChangesReq {
  req_hdr?: base.ReqHdr
  start_date?: string
  end_date?: string
  table_options?: commonHdr.ServerTableReq
  severity?: string
  alerts_only?: boolean
  resource_type?: string
  account_id?: string
}

export interface GetChangesResp {
  resp_hdr?: base.RespHdr
  change_count_list?: commonHdr.CommonTypeCount[]
  change_info_list?: ChangeInfo[]
  pages_count?: number
  total_count?: commonHdr.CommonTypeCount
}

export interface ProcessChangesReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface ProcessChangesResp {
  resp_hdr?: base.RespHdr
}

export interface GetChangesCountReq {
  req_hdr?: base.ReqHdr
  account_id?: string
}

export interface GetChangesCountResp {
  resp_hdr?: base.RespHdr
  high_count?: number
  total_count?: number
}

export enum ChangeTypeEnum {
  CHANGE_NONE = 'CHANGE_NONE',
  NODE_ADD = 'NODE_ADD',
  NODE_DEL = 'NODE_DEL',
  NODE_MODIFY = 'NODE_MODIFY',
  EDGE_ADD = 'EDGE_ADD',
  EDGE_DEL = 'EDGE_DEL',
  EDGE_MODIFY = 'EDGE_MODIFY'
}

export enum ApplicationType {
  APPLICATION_UNKNOWN = 'APPLICATION_UNKNOWN',
  IIQ = 'IIQ',
  IDN = 'IDN'
}
